import {doScrolling} from 'CommonUtils/scroll.js'

const elScrollBtn = document.querySelector(".triggerDiv");
const formContainer = document.querySelector(".targetDiv");
let main_header = document.getElementById("main-header");

elScrollBtn.addEventListener("click", () => {
    doScrolling(formContainer.getBoundingClientRect().top - document.body.getBoundingClientRect().top - main_header.offsetHeight -20, 500);
});

